module.exports = __webpack_public_path__ + "static/media/rank-06-experienced.52614664.svg";